var DropZoneErrorTypes;
(function (DropZoneErrorTypes) {
  DropZoneErrorTypes["NOT_AN_IMAGE"] = "NOT_AN_IMAGE";
  DropZoneErrorTypes["INVALID_FILE_EXTENSION"] = "INVALID_FILE_EXTENSION";
  DropZoneErrorTypes["PORTAL_SUSPENDED"] = "PORTAL_SUSPENDED";
  DropZoneErrorTypes["USER_WRITE_PERMISSION"] = "USER_WRITE_PERMISSION";
})(DropZoneErrorTypes || (DropZoneErrorTypes = {}));
export default DropZoneErrorTypes;